import React, { useEffect, useState } from "react";
import {
  PDFViewer,
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  pdf,
} from "@react-pdf/renderer";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";
// Install: npm install jsbarcode canvas
import JsBarcode from "jsbarcode";

const styles = StyleSheet.create({
  page: {
    padding: 8,
    fontSize: 8,
    fontFamily: "Helvetica",
    backgroundColor: "white",
  },
  topHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 3,
    padding: 4,
  },
  logo: {
    width: 60,
    height: 60,
    marginRight: 15,
  },
  headerText: {
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  schoolName2: {
    fontSize: 18,
    fontWeight: "bold",
    textAlign: "center",
    alignSelf: "center",
    marginBottom: 1,
  },
  schoolCode: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    alignSelf: "center",
    // marginBottom: 4,
    width: "100%",
  },
  infoSheet: {
    fontSize: 11,
    fontWeight: "bold",
    textAlign: "center",
    alignSelf: "center",
    width: "100%",
  },
  sectionHeader: {
    backgroundColor: "#d9d9d9",
    fontWeight: "bold",
    padding: 4,
    fontSize: 9,
    borderWidth: 1,
    borderColor: "#000",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    textAlign: "left",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderRightWidth: 0,
  },
  cellLeft: {
    flex: 1,
    padding: 5,
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: "#000",
    textAlign: "left",
  },
  cellLeft2: {
    flex: 1,
    padding: 5,
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: "#000",
    alignItems: "center",
    justifyContent: "center",
  },
  cellRight: {
    flex: 1,
    padding: 5,
    fontSize: 8,
    borderRightWidth: 1,
    borderRightColor: "#000",
    textAlign: "left",
  },
  cellRight2: {
    flex: 1,
    padding: 5,
    fontSize: 8,
    // borderRightWidth: 1,
    borderRightColor: "#000",
    textAlign: "left",
  },
  cellFullWidth: {
    padding: 4,
    fontSize: 9,
    borderLeftWidth: 1,
    borderLeftColor: "#000",
    borderRightWidth: 1,
    borderRightColor: "#000",
    textAlign: "left",
  },
  cellFullWidth2: {
    padding: 3,
    fontSize: 9,
    // borderLeftWidth: 1,
    borderLeftColor: "#000",
    // borderRightWidth: 1,
    borderRightColor: "#000",
    textAlign: "left",
  },
  boldLabel: {
    fontWeight: "bold",
    fontSize: 8,
  },
  boldLabel2: {
    fontWeight: "bold",
    fontSize: 8,
    textAlign: "center",
  },
  declaration: {
    fontSize: 9,
    marginTop: 15,
    textAlign: "justify",
    lineHeight: 1.4,
    fontWeight: "bold",
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 20,
    paddingTop: 15,
  },
  signatureBox: {
    width: "22%",
    textAlign: "center",
    fontSize: 9,
    borderTopWidth: 1,
    borderTopColor: "#000",
    paddingTop: 5,
  },
  tableContainer: {
    borderWidth: 1,
    borderColor: "#000",
  },
  col25: {
    width: "25%",
    height: 30,
    alignItems: "center",
    justifyContent: "center",
  },
  col50: {
    width: "50%",
    fontWeight: "bold",
    height: 30,
    fontSize: 12,
  },
  col75: {
    width: "75%",
  },
  col100: {
    width: "100%",
  },
  barcodeContainer: {
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  barcodeImage: {
    width: 100,
    height: 18,
  },
  studentIdText: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  declarationRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginVertical: 8,
  },
  checkIcon: {
    width: 8,
    height: 8,
    marginRight: 2,
    marginTop: 0,
  },
  declarationText: {
    fontSize: 8,
    color: "#222",
    lineHeight: 1.5,

    fontWeight: "bold",
  },
  imageContainer: {
    flexDirection: "row",
    gap: 10, // if using latest @react-pdf/renderer, otherwise use marginRight
  },
  image: {
    width: 90,
    marginTop: 0,
    height: 70,
    marginRight: 10,
  },
  image2: {
    width: 140,
    marginTop: 0,
    height: 60,
    marginRight: 10,
  },
});

// Function to generate barcode as base64 image
const generateBarcodeImage = (value) => {
  try {
    // Create a canvas element
    const canvas = document.createElement("canvas");

    // Generate barcode on canvas
    JsBarcode(canvas, value, {
      format: "CODE128",
      width: 2,
      height: 50,
      displayValue: false,
      background: "#ffffff",
      lineColor: "#000000",
      margin: 5,
    });

    // Convert canvas to base64
    return canvas.toDataURL();
  } catch (error) {
    console.error("Error generating barcode:", error);
    return null;
  }
};

// Individual Page Component for each student
const StudentPage = ({
  studentData,
  currentDateTime,
  schoolName,
  schoolCode,
  barcodeDataUrl,
}) => (
  <Page size="A4" style={styles.page}>
    {/* Header */}
    <View style={styles.topHeader}>
      <View style={styles.headerText}>
        <Text style={styles.schoolName2}>
          School Name: {studentData.schooL_NAME}
        </Text>
        <Text style={styles.schoolCode}>
          School Code: {studentData.schooL_CODE}
        </Text>
        <Text style={styles.infoSheet}>Class IX Student Information Sheet</Text>
      </View>
    </View>

    <View style={styles.tableContainer}>
      <View style={styles.tableRow}>
        <Text style={[styles.cellFullWidth2, styles.col50]}>Student Id.</Text>
        <Text
          style={[styles.cellFullWidth, styles.col25, styles.studentIdText]}
        >
          {studentData.candidatE_ID || "-"}
        </Text>
        <View
          style={[styles.cellFullWidth2, styles.col25, styles.barcodeContainer]}
        >
          {barcodeDataUrl && (
            <Image src={barcodeDataUrl} style={styles.barcodeImage} />
          )}
        </View>
      </View>
      <Text style={styles.sectionHeader}>Student Details</Text>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Candidate Name</Text>
        </Text>
        <Text style={styles.cellRight}>
          {studentData.candidatE_NAME || "-"}
        </Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Mother's Name</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.motheR_NAME || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Father's Name</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.fatheR_NAME || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Date of Birth</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.dob || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Gender</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.gender || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Religion</Text>
        </Text>
        <Text style={styles.cellRight2}>
          {studentData.religioN_NAME || "-"}
        </Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Nationality</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.nationality || "-"}</Text>

        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Aadhaar Number</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.aadhaR_CARD || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Divyang Category</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.divyanG_NAME || "-"}</Text>

        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Caste Category</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.castE_NAME || "-"}</Text>
      </View>
      <Text style={styles.sectionHeader}>Address Details</Text>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Area</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.area || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>State</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.statE_NAME || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>District</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.district || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Block</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.blocK_NAME || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Address</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.address || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Pin Code</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.pincode || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Contact Number </Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.contacT_NO || "-"}</Text>

        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Email ID</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.emaiL_ID || "-"}</Text>
      </View>
      <Text style={styles.sectionHeader}>Educational Details</Text>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Category Choice</Text>
        </Text>
        <Text style={styles.cellRight}>
          {studentData.prinT_CATEGORY || "-"}
        </Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Medium of Examination</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.mediuM_NAME || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Language I Subject</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.subjecT_1 || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Language II Subject</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.subjecT_2 || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Compulsory I Subject </Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.subjecT_3 || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Compulsory II Subject </Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.subjecT_4 || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Compulsory III Subject</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.subjecT_5 || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Additional subject </Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.subjecT_6 || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Board</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.boarD_NAME || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>APAAR ID</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.apaaR_ID || "-"}</Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Section</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.section || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Class Roll No</Text>
        </Text>
        <Text style={styles.cellRight2}>
          {studentData.clasS_ROLL_NO || "-"}
        </Text>
      </View>
      {/* <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Roll Number</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.Roll_Number || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Centre Code</Text>
        </Text>
        <Text style={styles.cellRight2}>{studentData.Centre_Code || "-"}</Text>
      </View> */}
      {/* <View style={styles.tableRow}>
        <Text style={[styles.cellLeft, { flex: 0.93 }]}>
          <Text style={styles.boldLabel}>Centre Name</Text>
        </Text>
        <Text style={[styles.cellRight2, { flex: 3 }]}>
          {studentData.Centre_Name || "-"}
        </Text>
      </View> */}
      <Text style={styles.sectionHeader}>Images Uploaded</Text>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel2}>Photograph </Text>
        </Text>
        <Text style={styles.cellRight2}>
          <Text style={styles.boldLabel2}>Signature </Text>
        </Text>
      </View>
      <View style={styles.tableRow}>
        <View style={styles.cellLeft2}>
          {/* <Text style={styles.boldLabel}>Photograph:</Text> */}
          <Image
            style={styles.image}
            src={(studentData.studenT_PHOTOGRAPH_URL || "").replace(
              "http://",
              "https://"
            )}
          />
        </View>
        <View style={styles.cellLeft2}>
          {/* <Text style={styles.boldLabel}>Signature:</Text> */}
          <Image
            style={styles.image2}
            src={(studentData.studenT_SIGNATURE_URL || "").replace(
              "http://",
              "https://"
            )}
          />
        </View>
      </View>
      ;
      <View style={styles.tableRow}>
        <Text style={styles.cellRight2}>
          <Text style={styles.boldLabel}>List of Documents Uploaded :</Text>
          <Text>
            Photograph ,Signature
            {studentData.castE_CERTIFICATE === null
              ? ""
              : ", Caste Certificate"}
            {studentData.divyanG_CERTIFICATE === null
              ? ""
              : ", Divyang Certificate"}
          </Text>
        </Text>
      </View>
      <Text style={styles.sectionHeader}>Submission Details</Text>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Form Submission Date & Time</Text>
        </Text>
        <Text style={styles.cellRight}>
          {studentData.applY_SYS_DATE || "-"}
        </Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Last Edit Date & Time</Text>
        </Text>
        <Text style={styles.cellRight2}>
          {studentData.lasT_UPDATE_DATE_TIME || "-"}
        </Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>DEO Approval Status</Text>
        </Text>
        <Text style={styles.cellRight}>{studentData.deO_STATUS || "-"}</Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>DEO Approval Date & Time</Text>
        </Text>
        <Text style={styles.cellRight2}>
          {studentData.deO_APPROVAL_DATETIME || "-"}
        </Text>
      </View>
      <View style={styles.tableRow}>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}>Checklist Print Date & Time</Text>
        </Text>
        <Text style={styles.cellRight}>
          {studentData.checklisT_PRINT_DATE_TIME || currentDateTime}
        </Text>
        <Text style={styles.cellLeft}>
          <Text style={styles.boldLabel}></Text>
        </Text>
        <Text style={styles.cellRight2}></Text>
      </View>
    </View>

    <View style={styles.declarationRow}>
      <Image
        src="https://cdn-icons-png.flaticon.com/128/3388/3388530.png"
        style={styles.checkIcon}
      />
      <Text style={styles.declarationText}>
        I hereby declare that I have diligently verified all the information
        presented in this document. I affirm that the content herein is true,
        authentic, and accurate to the best of my knowledge.
      </Text>
    </View>

    <View style={styles.signatureSection}>
      <Text style={styles.signatureBox}>Student's Signature</Text>
      <Text style={styles.signatureBox}>Parent's Signature</Text>
      <Text style={styles.signatureBox}>Class Teacher's Signature</Text>
      <Text style={styles.signatureBox}>Principal's Signature</Text>
    </View>
  </Page>
);

// Main PDF Document Component
const StudentInfoSheet = ({
  studentData,
  currentDateTime,
  schoolName,
  schoolCode,
  barcodeImages,
}) => {
  const studentsArray = Array.isArray(studentData)
    ? studentData
    : [studentData];

  if (!studentsArray.length) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text>No student data found</Text>
        </Page>
      </Document>
    );
  }

  return (
    <Document>
      {studentsArray.map((student, index) => (
        <StudentPage
          key={student.candidatE_ID || index}
          studentData={student}
          currentDateTime={currentDateTime}
          schoolName={schoolName}
          schoolCode={schoolCode}
          barcodeDataUrl={barcodeImages[student.candidatE_ID] || null}
        />
      ))}
    </Document>
  );
};

// Main Component
const Checklist = () => {
  const [studentData, setStudentData] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [barcodeImages, setBarcodeImages] = useState({});

  // Generate barcodes for all students
  const generateBarcodesForStudents = (students) => {
    const barcodes = {};
    students.forEach((student) => {
      if (student.candidatE_ID) {
        const barcodeDataUrl = generateBarcodeImage(student.candidatE_ID);
        if (barcodeDataUrl) {
          barcodes[student.candidatE_ID] = barcodeDataUrl;
        }
      }
    });
    setBarcodeImages(barcodes);
  };

  useEffect(() => {
    setCurrentDateTime(new Date().toLocaleString());

    const fetchData = async () => {
      try {
        setLoading(true);
        const token = sessionStorage.getItem("tokenclassix");

        const storedSupplementaryIds = JSON.parse(
          sessionStorage.getItem("selectedCandidates") || "[]"
        );
        const candidateIdString = storedSupplementaryIds.join(",");

        const response = await axios.post(
          `${config.API_BASE_URL}/CheckListGeneratedByCandidateID_CL9`,
          {
            candidatE_ID: candidateIdString,
            // schooL_CODE: sessionStorage.getItem("schoolCode"),
            districtcode: sessionStorage.getItem("district"),
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (
          response.status === 200 &&
          response.data &&
          response.data.data &&
          Array.isArray(response.data.data["checklist_data"]) &&
          response.data.data["checklist_data"].length > 0
        ) {
          const students = response.data.data["checklist_data"];
          setStudentData(students);
          // Generate barcodes after setting student data
          generateBarcodesForStudents(students);
        } else {
          Swal.fire("Error", "Error fetching checklist data.", "error");
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire(
          "Error",
          "Something went wrong while fetching data.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handlePrint = async () => {
    try {
      const blob = await pdf(
        <StudentInfoSheet
          studentData={studentData}
          currentDateTime={currentDateTime}
          schoolName={
            sessionStorage.getItem("schoolname") || "Default School Name"
          }
          schoolCode={
            sessionStorage.getItem("schoolcode") || "Default School Code"
          }
          barcodeImages={barcodeImages}
        />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url);

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.focus();
          newWindow.print();
        };
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire("Error", "Failed to generate PDF", "error");
    }
  };

  return (
    <div>
      {loading ? (
        <div>Loading data...</div>
      ) : studentData.length > 0 ? (
        <>
          <div style={{ textAlign: "right" }}>
            <button
              style={{ margin: "5px 5px 0px 0px" }}
              onClick={handlePrint}
              className="btn btn-danger btn-sm"
            >
              <i className="fa fa-print"></i> Print PDF ({studentData.length}{" "}
              student{studentData.length > 1 ? "s" : ""})
            </button>
          </div>

          <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <StudentInfoSheet
              studentData={studentData}
              currentDateTime={currentDateTime}
              schoolName={
                sessionStorage.getItem("schoolname") || "Default School Name"
              }
              schoolCode={
                sessionStorage.getItem("schoolCode") || "Default School Code"
              }
              barcodeImages={barcodeImages}
            />
          </PDFViewer>
        </>
      ) : (
        <div>No data available</div>
      )}
    </div>
  );
};

export default Checklist;
